import Button from "@src/modules/shared/components/Button";
import {
  ButtonsWrapper,
  Container,
  Message,
  Title,
} from "@src/modules/shared/components/GlobalErrorFallback/GlobalErrorFallback.components";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

const GlobalErrorFallback: FunctionComponent = () => {
  const { t } = useTranslation();
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Container>
      <Title>{t("Oops! Something went wrong.")}</Title>
      <Message>
        {t(
          "We apologize for the inconvenience. An unexpected error occurred. Our technical team has been automatically notified and is working on a fix.",
        )}
      </Message>
      <ButtonsWrapper>
        <Button onClick={handleReload} buttonType="primary">
          {t("Reload Application")}
        </Button>
        <Button
          onClick={() =>
            (window.location.href = "mailto:support@diagnomatic.com")
          }
          buttonType="tertiary"
        >
          {t("Contact Support")}
        </Button>
      </ButtonsWrapper>
    </Container>
  );
};

export default GlobalErrorFallback;
